import { Filter } from '@creditsights/styleguide-web';
import { orderBy } from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import useFetchCompanyDocsTypes from '../../../../../hooks/documents/useFetchFilingsTypes';
import { FilterRendererProps } from '../../GroupedTableRow/GroupedTableRow.types';

const FilingsTypeFilterRenderer = <TData,>({
  value,
  columnConfig: { dataKey },
  data,
  onFilter,
}: FilterRendererProps<TData, number[] | undefined>): React.ReactElement => {
  const { data: types } = useFetchCompanyDocsTypes();
  const isInitialState = value === undefined || value.length === 0;
  const [storedOptions, setStoredOptions] = useState<any>([]);

  useEffect(() => {
    if (isInitialState) {
      const flattenedDocuments = data?.results.flat(Infinity);

      const newOptions = orderBy(
        types
          ?.filter((type) => flattenedDocuments?.some((document) => document[dataKey] === type.id))
          .map((item) => ({
            key: `${item.id}`,
            title: item.name,
          })) || [],
        'title',
        'asc'
      );

      setStoredOptions(newOptions);
    }
  }, [types, data, dataKey, isInitialState]);

  const checkedKeys = useMemo(() => value?.map((item) => `${item}`) || [], [value]);

  const handleChange = useCallback(
    (values: string[]) => {
      onFilter(values.map((item) => +item));
    },
    [onFilter, value]
  );

  return <Filter data={storedOptions} placeholder="Filter" onChange={handleChange} checkedKeys={checkedKeys} />;
};

export default FilingsTypeFilterRenderer;
